import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { BillingCallbackPage } from "@/components/Pages/Billing";

const billingCallbackSearchSchema = z.object({
  status: z.enum(["success", "failed"]).optional(),
});

export const Route = createFileRoute("/billing/callback")({
  validateSearch: billingCallbackSearchSchema,
  component: function BillingCallbackRoute() {
    const { status } = Route.useSearch();
    return <BillingCallbackPage status={status} />;
  },
});
